"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionSampleRate = getSessionSampleRate;
exports.addCustomRUMError = exports.setUser = exports.addCustomRUMEvent = exports.initializeRealUserMonitoring = void 0;

var _browserRumSlim = require("@datadog/browser-rum-slim");

var _featureDetection = require("@eventbrite/feature-detection");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var addEBSessionId = function addEBSessionId(options) {
  var _window$__SERVER_DATA, _window$__SERVER_DATA2;

  if (!_featureDetection.HAS_WINDOW) {
    return;
  }

  var sessionId = options.ebSessionId || ((_window$__SERVER_DATA = window.__SERVER_DATA__) === null || _window$__SERVER_DATA === void 0 ? void 0 : (_window$__SERVER_DATA2 = _window$__SERVER_DATA.request) === null || _window$__SERVER_DATA2 === void 0 ? void 0 : _window$__SERVER_DATA2.session_id); //Necessary to wrap the call in onReady as setGlobalContextProperty only operates
  //onces RUM instance is already created.
  //https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=cdnasync#add-global-context

  if (sessionId) {
    _browserRumSlim.datadogRum.onReady(function () {
      return _browserRumSlim.datadogRum.setGlobalContextProperty('session.eb_session_id', sessionId);
    });
  }
};
/**
 *   __ebuiRUMInit is declared globally in an inline script,
 *   the responsibility of the function is to indicate that RUM is ready
 *   TODO: add to eb-ui docs about tracking custom paint actions
 */


var notifyRUMReady = function notifyRUMReady() {
  if (!_featureDetection.HAS_WINDOW) {
    return;
  }

  _browserRumSlim.datadogRum.onReady(function () {
    window.__ebuiRUMInit && window.__ebuiRUMInit();
  });
};

function getSessionSampleRate(options) {
  var sampleRate = (options === null || options === void 0 ? void 0 : options.sessionSampleRate) || 0;

  if (_featureDetection.HAS_WINDOW && (0, _featureDetection.getWindowObject)('navigator') && !options.enableBots) {
    var botRegex = new RegExp(_constants.BOT_REGEX_PATTERN, 'i');
    sampleRate = botRegex.test(navigator.userAgent) ? 0 : sampleRate;
  }

  return sampleRate;
}

var initializeRealUserMonitoring = function initializeRealUserMonitoring(options) {
  if (!_featureDetection.HAS_WINDOW) {
    return;
  }

  var currentEnv = options.env ? options.env : (0, _featureDetection.getCurrentEnv)() || undefined;

  if (options.enabledEnvironments && currentEnv && !options.enabledEnvironments.includes(currentEnv)) {
    return;
  }

  var clientToken = options.clientToken || _constants.WEB_TRIAL_CLIENT_TOKEN;
  var applicationId = options.applicationId || _constants.WEB_TRIAL_APP_TOKEN;
  var version = options.version || '';
  var service = options.service ? "rum-web--".concat(options.service) : 'rum-web';
  var sessionSampleRate = getSessionSampleRate(options);

  _browserRumSlim.datadogRum.init(_objectSpread(_objectSpread({}, options), {}, {
    applicationId: applicationId,
    clientToken: clientToken,
    version: version,
    service: service,
    sessionSampleRate: sessionSampleRate,
    site: 'datadoghq.com',
    trackUserInteractions: true,
    env: currentEnv
  }));

  addEBSessionId(options);
  notifyRUMReady();
};
/**
 * Thin wrapper to pass a custom action to the RUM tracking instance
 * defined on the window.
 *
 * @generic RUMEvents
 *      The shape of the events that your application supports
 *      eg. type MyEvents = {search: {query: string;}}
 *
 * @param name Top level key defined in the passed in RUMEvents
 *
 * @param data Payload to send for a given event
 */


exports.initializeRealUserMonitoring = initializeRealUserMonitoring;

var addCustomRUMEvent = function addCustomRUMEvent(name, data) {
  if (typeof window !== 'undefined' && window.DD_RUM && window.DD_RUM.addAction) {
    window.DD_RUM.addAction(name, data);
  }
};

exports.addCustomRUMEvent = addCustomRUMEvent;
var setUser = _browserRumSlim.datadogRum.setUser;
/**
 * Thin wrapper to pass a custom error to the RUM tracking instance
 * defined on the window.
 *
 * @param error Error to send to DD
 *
 * @param context Payload to send for a given error
 */

exports.setUser = setUser;

var addCustomRUMError = function addCustomRUMError(error, context) {
  if (typeof window !== 'undefined' && window.DD_RUM && window.DD_RUM.addError) {
    window.DD_RUM.addError(error, context);
  }
};

exports.addCustomRUMError = addCustomRUMError;
//# sourceMappingURL=rum.js.map